import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import Logs from "./logs";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<Logs />} />
    </Routes>
  );
};

export default View;
